import CommandFactory from '../commands/CommandFactory';
import GraphicFactory from '../components/GraphicFactory';

/**
 *
 *
 * @export
 * @class Tools
 */
export default class Tools {
  constructor() {
    this._app = null;
    this._option = null;
    this._lastGraphic = null;
    this._currentGraphicId = -1;
    this._currentToolId = -1;
    this._currentTool = null;
    this._defaultControlOption = {
      hasControls: true, // 是否有控制条
      hasBorders: true, // 每个控制块之间是否有连接线
      hasRotatingPoint: true, // 是否有旋转控制块
      transparentCorners: false, // 方向控制块是否是透明
      cornerStyle: 'circle', // 控制块样式， 支持:"circle", "square"
      padding: 8, // 控制块与元件的边界
      cornerSize: 16, // 控制块大小，单位px
      rotatingPointOffset: 35, // 旋转控制块的距离元件的距离
      borderColor: '#00FF00', // 连接线颜色
      cornerColor: '#0000FF', // 控制块填充色颜色
      cornerStrokeColor: '#FFFF00' // 控制块描边颜色
    };

    this.originOption = null;
    this.commandFactory = new CommandFactory();

    this.optionMap = new Map();
  }

  set app(val) {
    this._app = val;
    this.commandFactory.app = this.app;
  }

  get app() {
    return this._app;
  }
  set option(val) {
    this._option = val;
    // 如果没有设置工具的话，忽略此次设置
    if (this._currentGraphicId === -1) {
      return;
    }

    let currentOption = this.optionMap.get(this._currentGraphicId);
    if (!currentOption) {
      this.optionMap.set(this._currentGraphicId, this.currentGraphic.defaultOption);
    }

    Object.assign(currentOption, val);

    // 设置当前图形的设置为opt
    this.currentGraphic.option = currentOption;
    this.optionMap.set(this._currentGraphicId, currentOption);
  }

  get option() {
    return this.currentGraphic.option;
  }

  set currentGraphic(val) {
    if (this._lastGraphic) {
      this._lastGraphic.stop();
    }

    if (this._lastTool) {
      this._lastTool.complete();
    }
    let factory = this.app.graphicFactory;
    this._currentGraphic = factory.createGraphic(val);

    if (this._currentGraphic) {
      this._lastGraphic = this._currentGraphic;

      let opt = this.optionMap.get(val);
      if (!opt) {
        opt = this._currentGraphic.defaultOption;
        this.optionMap.set(val, opt);
      }

      this._currentGraphic.option = opt;
      this._currentGraphic.app = this.app;
      this._currentGraphic.start();
    }
    this._currentGraphicId = val;
  }

  get currentGraphic() {
    return this._currentGraphic;
  }

  get currentGraphicId() {
    return this._currentGraphicId;
  }

  set currentTool(val) {
    this._currentToolId = val;

    this._currentTool = this.commandFactory.createCommand(val);
    if (this._lastTool) {
      this._lastTool.complete();
    }

    if (this._lastGraphic) {
      this._lastGraphic.stop();
    }

    if (this._currentTool) {
      this._lastTool = this._currentTool;
      this._currentTool.execute();
    }
  }

  get currentTool() {
    return this._currentTool;
  }

  set defaultControlOption(opt) {
    Object.assign(this._defaultControlOption, opt);
  }

  /**
   *
   * 获取所有物件的控制条样式
   * @memberof ToolsManager
   */
  get defaultControlOption() {
    return this._defaultControlOption;
  }

  set zoomOption(opt) {
    this._zoomOption = opt;
  }

  get zoomOption() {
    return this._zoomOption;
  }
}
